<template>
    <div>
        <v-dialog persistent
                  v-model="$store.getters.publisherHistory"
                  max-width="700">

            <v-card>
                <v-card-title
                        class="headline primary white--text"
                        primary-title>
                    Ιστορικό Συμμετοχής
                </v-card-title>

                <v-card-text class="mt-5">
                    <v-data-table
                            no-data-text="Δεν υπάρχουν δεδομένα."
                            :headers="$store.getters.homePageInformation.type != 'Allocator'? headers: allocatorHeaders"
                            :items="publisherHistory"
                            :items-per-page="5"
                            sort-by.sync="year"
                            :sort-desc=sortDesc
                            sort-by="year"
                            class="elevation-1">
                        <template v-slot:item="{ item }">
                            <tr >
                                <td class="text-center d-sm-table-cell d-flex">{{ item.year }}</td>
                                <td class="text-center d-sm-table-cell d-flex">
                                    <v-icon color="lightSeaGreen" v-if="item.eudoxusMember">mdi-check-all</v-icon>
                                    <v-icon color="indianRed" v-else>mdi-close</v-icon>
                                </td>
<!--                                <td class="text-center d-sm-table-cell d-flex">-->

<!--                                    <v-icon color="lightSeaGreen" v-if="item.eBookstoreMembership">mdi-check-all</v-icon>-->
<!--                                    <v-icon color="indianRed" v-else>mdi-close</v-icon>-->

<!--                                </td>-->
<!--                                <td v-if="$store.getters.homePageInformation.type != 'Allocator'" class="text-center d-sm-table-cell d-flex">-->
<!--                                    <v-tooltip right>-->
<!--                                        <template v-slot:activator="{ on }">-->
<!--                                            <v-icon :disabled="item.year!==$store.getters.editedYear ? true : item.eudoxusMember===false ? true: item.eBookstoreMembership ? true : false  "-->
<!--                                                    color="info"-->
<!--                                                    @click="setBookstoreMembership"-->
<!--                                                    v-on="on">mdi-book-open-->
<!--                                            </v-icon>-->
<!--                                        </template>-->
<!--                                        <span>Συμμετοχή</span>-->
<!--                                    </v-tooltip>-->
<!--                                </td>-->
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            text
                            @click="closeModal">
                        Κλείσιμο
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    import request from "../../requests";
    import utils from "../../utilities";

    export default {
        name: "PublisherHistory",
        data: () => ({
            headers: [
                { text: 'Έτος', value: 'year', align: 'center' },
                { text: 'Εύδοξος', value: 'eudoxusMember', align: 'center' },
                // { text: 'Βιβλιοθήκη Ηλ.Συγγραμμάτων', value: 'eBookstoreMembership', align: 'center' },
                //{ text: 'Συμμετοχή στο Η/Β', align: 'center' },
            ],
            allocatorHeaders: [
                { text: 'Έτος', value: 'year', align: 'center' },
                { text: 'Εύδοξος', value: 'eudoxusMember', align: 'center' },
                // { text: 'Βιβλιοθήκη Ηλ.Συγγραμμάτων', value: 'eBookstoreMembership', align: 'center' },
            ],
            sortDesc:true,
        }),

        props: {
            publisherHistory: Array
        },

        methods: {
            setBookstoreMembership(){
                request.redirectToBookstore(this.redirectToBookstoreCallBack);
            },

            redirectToBookstoreCallBack(response){
                alert(" Παρακαλούμε περιμένετε για μεταφερθείτε στην Βιβλιοθήκη Ηλεκτρονικών Συγγραμμάτων");
                this.$store.commit('setLoadingModal', true);
                //request.redirectToBookstore(this.redirectToBookstoreCallBack);
                window.open(response.redirectUrl,"_self");
            },

            closeModal(){
                this.$store.commit('setPublisherHistory', false);
            }
        }
    }
</script>

<style scoped>

</style>